.form {
  display: var(--haus-quickOrder__form__display, flex);
  flex-direction: var(--haus-quickOrder__form__flex-direction, column);
  gap: var(--haus-quickOrder__form__gap, 0);
  width: var(--haus-quickOrder__form__width, 100%);
}

.manualPanel {
  display: var(--haus-quickOrder__manualPanel__display, flex);
  flex-direction: var(--haus-quickOrder__manualPanel__flex-direction, column);
  width: var(--haus-quickOrder__manualPanel__width, 100%);
}

.resultMessageError,
.resultMessageSuccess {
  padding: var(--haus-quickOrder__resultMessage__padding, 1rem);
  border-radius: var(--haus-quickOrder__resultMessage__border-radius, 0.5rem);
  margin-bottom: var(--haus-quickOrder__resultMessage__margin-bottom, 1rem);
}

.resultMessageError {
  background: var(--haus-quickOrder__resultMessageError__background, #fef2f2);
  border: var(--haus-quickOrder__resultMessageError__border, 1px solid #fecaca);
}

.resultMessageSuccess {
  background: var(--haus-quickOrder__resultMessageSuccess__background, #e8f5e9);
  border: var(--haus-quickOrder__resultMessageSuccess__border, 1px solid #4caf50);
}

.columnHeaderSku {
  font-weight: var(--haus-quickOrder__columnHeader__font-weight, 500);
  color: var(--haus-quickOrder__columnHeader__color, var(--haus-color-text, #000));
  font-size: var(--haus-quickOrder__columnHeader__font-size, 0.85rem);
  line-height: var(--haus-quickOrder__columnHeader__line-height, 1.2);
  letter-spacing: var(--haus-quickOrder__columnHeader__letter-spacing, 0.01em);
  font-family: var(--haus-quickOrder__columnHeader__font-family, var(--haus-font-family-body));
}

.formHeader {
  display: var(--haus-quickOrder__formHeaderMobile__display, none);
}

.mobileOnlyHeader {
  display: var(--haus-quickOrder__mobileOnlyHeaderMobile__display, block);
  margin-bottom: var(--haus-quickOrder__mobileOnlyHeader__margin-bottom, 0.125rem);
}

.formRows {
  margin-bottom: var(--haus-quickOrder__formRows__margin-bottom, 1rem);
}

.formRow {
  display: var(--haus-quickOrder__formRow__display, flex);
  flex-direction: var(--haus-quickOrder__formRow__flex-direction, column);
  row-gap: var(--haus-quickOrder__formRowMobile__row-gap, 0.5rem);
  border: var(--haus-quickOrder__formRowMobile__border, 1px solid #0000001a);
  border-radius: var(--haus-quickOrder__formRowMobile__border-radius, 8px);
  padding: var(--haus-quickOrder__formRowMobile__padding, 1rem);
  margin: var(--haus-quickOrder__formRowMobile__margin, 0.5rem 0);
}

.formRowGrid {
  display: var(--haus-quickOrder__formRowGrid__display, flex);
  flex-direction: var(--haus-quickOrder__formRowGridMobile__flex-direction, column);
  align-items: var(--haus-quickOrder__formRowGridMobile__align-items, flex-start);
  width: var(--haus-quickOrder__formRowGrid__width, 100%);
  row-gap: var(
    --haus-quickOrder__formRowGridMobile__row-gap,
    var(--haus-quickOrder__formRowMobile__row-gap, 0.5rem)
  );
}

.inputCellSku {
  display: var(--haus-quickOrder__inputCellSku__display, flex);
  flex-direction: var(--haus-quickOrder__inputCellSkuMobile__flex-direction, column);
  row-gap: var(--haus-quickOrder__inputCellSkuMobile__row-gap, 0.375rem);
  width: var(--haus-quickOrder__inputCellSkuMobile__width, 100%);
}

.inputCellActions {
  display: var(--haus-quickOrder__inputCellActions__display, flex);
  gap: var(--haus-quickOrder__inputCellActions__gap, 0.5rem);
  align-items: var(--haus-quickOrder__inputCellActionsMobile__align-items, flex-end);
  justify-content: var(--haus-quickOrder__inputCellActions__justify-content, flex-end);
  width: var(--haus-quickOrder__inputCellActionsMobile__width, 100%);
}

.quantityInputGroup {
  display: var(--haus-quickOrder__quantityInputGroupMobile__display, flex);
  flex-direction: var(--haus-quickOrder__quantityInputGroupMobile__flex-direction, column);
  row-gap: var(--haus-quickOrder__quantityInputGroupMobile__row-gap, 0.375rem);
  width: var(--haus-quickOrder__quantityInputGroupMobile__width, 100%);
}

.inputCellActions input {
  text-align: var(--haus-quickOrder__inputCellQuantity__text-align, center);
}

.formActions {
  display: var(--haus-quickOrder__formActions__display, flex);
  gap: var(--haus-quickOrder__formActions__gap, 0.75rem);
  justify-content: var(--haus-quickOrder__formActions__justify-content, flex-end);
  flex-wrap: var(--haus-quickOrder__formActions__flex-wrap, wrap);
}

.submitButton {
  width: var(--haus-quickOrder__submitButton__width, auto);
}

.clearButton {
  width: var(--haus-quickOrder__clearButton__width, auto);
}

.manualRowError {
  display: var(--haus-quickOrder__manualRowError__display, block);
  color: var(--haus-quickOrder__manualRowError__color, #b91c1c) !important;
  font-size: var(--haus-quickOrder__manualRowError__font-size, 0.8125rem);
}

.removeButton {
  display: var(--haus-quickOrder__removeButton__display, flex);
  align-items: var(--haus-quickOrder__removeButton__align-items, center);
  justify-content: var(--haus-quickOrder__removeButton__justify-content, center);
  width: var(--haus-quickOrder__removeButton__width, 2.5rem);
  height: var(--haus-quickOrder__removeButton__height, 2.5rem);
  background: var(--haus-quickOrder__removeButton__background, #ffffff);
  color: var(--haus-quickOrder__removeButton__color, #b91c1c);
  cursor: var(--haus-quickOrder__removeButton__cursor, pointer);
  border: var(--haus-quickOrder__removeButton__border, none);
  border-radius: var(--haus-quickOrder__removeButton__border-radius, 0);
  transition: var(
    --haus-quickOrder__removeButton__transition,
    border-color 0.2s,
    background-color 0.2s,
    color 0.2s
  );
}

.removeButton:focus-visible {
  outline: var(--haus-quickOrder__removeButtonFocus__outline, none);
  border-color: var(--haus-quickOrder__removeButtonFocus__border-color, #111827);
  box-shadow: var(
    --haus-quickOrder__removeButtonFocus__box-shadow,
    0 0 0 0.1875rem rgba(17, 24, 39, 0.08)
  );
}

.removeButton:disabled {
  opacity: var(--haus-quickOrder__removeButtonDisabled__opacity, 0.3);
  cursor: var(--haus-quickOrder__removeButtonDisabled__cursor, not-allowed);
}

.addRowButton {
  display: var(--haus-quickOrder__addRowButton__display, flex);
  align-items: var(--haus-quickOrder__addRowButton__align-items, center);
  justify-content: var(--haus-quickOrder__addRowButton__justify-content, center);
  gap: var(--haus-quickOrder__addRowButton__gap, 0.5rem);
  padding: var(--haus-quickOrder__addRowButton__padding, 0.75rem 1rem);
  border: var(--haus-quickOrder__addRowButton__border, 0.0625rem dashed #d1d5db);
  background: var(--haus-quickOrder__addRowButton__background, #f9fafb);
  color: var(--haus-quickOrder__addRowButton__color, #4b5563);
  border-radius: var(--haus-quickOrder__addRowButton__border-radius, 0.5rem);
  cursor: var(--haus-quickOrder__addRowButton__cursor, pointer);
  width: var(--haus-quickOrder__addRowButton__width, 100%);
  font-size: var(--haus-quickOrder__addRowButton__font-size, 0.9rem);
  transition:
    border-color 0.2s,
    color 0.2s;
  margin-bottom: var(--haus-quickOrder__addRowButton__margin-bottom, 1rem);
  min-height: var(--haus-quickOrder__addRowButton__min-height, 2.75rem);
}

.addRowButton:disabled {
  opacity: var(--haus-quickOrder__addRowButtonDisabled__opacity, 0.5);
  cursor: var(--haus-quickOrder__addRowButtonDisabled__cursor, not-allowed);
}

.autocompleteRoot {
  position: var(--haus-quickOrder__autocompleteRoot__position, relative);
  width: var(--haus-quickOrder__autocompleteRoot__width, 100%);
}

.autocompleteInput {
  box-sizing: border-box;
  --haus-input-width: var(--haus-quickOrder__autocompleteInput__width, 100%);
  --haus-input-border: var(--haus-quickOrder__autocompleteInput__border, 0.0625rem solid #d1d5db);
  --haus-input-border-radius: var(--haus-quickOrder__autocompleteInput__border-radius, 0.5rem);
  --haus-input-focus-outline: var(--haus-quickOrder__autocompleteInputFocus__outline, none);
  --haus-input-focus-outline-offset: var(
    --haus-quickOrder__autocompleteInputFocus__outline-offset,
    0
  );
  --haus-input-focus-border-color: var(
    --haus-quickOrder__autocompleteInputFocus__border-color,
    #111827
  );
  --haus-input-focus-box-shadow: var(
    --haus-quickOrder__autocompleteInputFocus__box-shadow,
    0 0 0 0.1875rem rgba(17, 24, 39, 0.08)
  );
}

.autocompleteInputError {
  --haus-input-border: var(
    --haus-quickOrder__autocompleteInputError__border,
    0.0625rem solid #dc2626
  );
  --haus-input-focus-border-color: var(
    --haus-quickOrder__autocompleteInputErrorFocus__border-color,
    #b91c1c
  );
  --haus-input-focus-box-shadow: var(
    --haus-quickOrder__autocompleteInputErrorFocus__box-shadow,
    0 0 0 0.1875rem rgba(185, 28, 28, 0.16)
  );
}

.autocompletePopover {
  width: var(--haus-quickOrder__autocompletePopover__width, var(--radix-popover-trigger-width));
  max-height: var(--haus-quickOrder__autocompletePopover__max-height, 14rem);
  overflow: var(--haus-quickOrder__autocompletePopover__overflow, auto);
  background-color: var(--haus-quickOrder__autocompletePopover__background-color, #ffffff);
  border: var(--haus-quickOrder__autocompletePopover__border, 0.0625rem solid #e5e7eb);
  border-radius: var(--haus-quickOrder__autocompletePopover__border-radius, 0.5rem);
  box-shadow: var(
    --haus-quickOrder__autocompletePopover__box-shadow,
    0 0.25rem 0.75rem rgba(0, 0, 0, 0.12)
  );
  opacity: var(--haus-quickOrder__autocompletePopover__opacity, 1);
  backdrop-filter: var(--haus-quickOrder__autocompletePopover__backdrop-filter, none);
  z-index: var(--haus-quickOrder__autocompletePopover__z-index, 20);
}

.autocompleteListbox {
  display: var(--haus-quickOrder__autocompleteListbox__display, flex);
  flex-direction: var(--haus-quickOrder__autocompleteListbox__flex-direction, column);
}

.autocompleteOption {
  display: var(--haus-quickOrder__autocompleteOption__display, flex);
  flex-direction: var(--haus-quickOrder__autocompleteOption__flex-direction, column);
  align-items: var(--haus-quickOrder__autocompleteOption__align-items, flex-start);
  width: var(--haus-quickOrder__autocompleteOption__width, 100%);
  padding: var(--haus-quickOrder__autocompleteOption__padding, 0.625rem 0.75rem);
  border: var(--haus-quickOrder__autocompleteOption__border, none);
  border-bottom: var(--haus-quickOrder__autocompleteOption__border-bottom, 0.0625rem solid #f2f2f2);
  background: var(--haus-quickOrder__autocompleteOption__background, #fff);
  color: var(--haus-quickOrder__autocompleteOption__color, #222);
  cursor: var(--haus-quickOrder__autocompleteOption__cursor, pointer);
  text-align: var(--haus-quickOrder__autocompleteOption__text-align, left);
  font-size: var(--haus-quickOrder__autocompleteOption__font-size, 0.875rem);
}

.autocompleteOption:last-child {
  border-bottom: none;
}

.autocompleteOption[data-active-item] {
  background: var(--haus-quickOrder__autocompleteOptionActive__background, #f3f4f6);
}

.autocompleteOption[data-selected] {
  background: var(--haus-quickOrder__autocompleteOptionSelected__background, #eef2ff);
}

.autocompleteOptionColumns {
  display: var(--haus-quickOrder__autocompleteOptionColumns__display, grid);
  grid-template-columns: var(
    --haus-quickOrder__autocompleteOptionColumns__grid-template-columns,
    minmax(7rem, 9rem) 1fr
  );
  column-gap: var(--haus-quickOrder__autocompleteOptionColumns__column-gap, 0.5rem);
  align-items: var(--haus-quickOrder__autocompleteOptionColumns__align-items, center);
  width: var(--haus-quickOrder__autocompleteOptionColumns__width, 100%);
}

.autocompleteOptionLabel {
  color: var(--haus-quickOrder__autocompleteOptionLabel__color, #666);
  font-size: var(--haus-quickOrder__autocompleteOptionLabel__font-size, 0.8125rem);
}

.autocompleteStatus {
  padding: var(--haus-quickOrder__autocompleteStatus__padding, 0.625rem 0.75rem);
  color: var(--haus-quickOrder__autocompleteStatus__color, #666);
  font-size: var(--haus-quickOrder__autocompleteStatus__font-size, 0.875rem);
}

@media (min-width: 768px) {
  .formHeader {
    display: var(--haus-quickOrder__formHeader__display, grid);
    grid-template-columns: var(--haus-quickOrder__formHeader__grid-columns, 1fr 11.375rem);
    gap: var(--haus-quickOrder__formHeader__gap, 1rem);
    padding: var(--haus-quickOrder__formHeader__padding, 0.75rem 0);
    border-bottom: var(--haus-quickOrder__formHeader__border-bottom, 0.0625rem solid #e5e7eb);
    margin-bottom: var(--haus-quickOrder__formHeader__margin-bottom, 0.5rem);
  }

  .mobileOnlyHeader {
    display: var(--haus-quickOrder__mobileOnlyHeader__display, none);
  }

  .formRow {
    row-gap: var(--haus-quickOrder__formRow__row-gap-desktop, 0);
    border: var(--haus-quickOrder__formRow__border-desktop, none);
    border-radius: var(--haus-quickOrder__formRow__border-radius-desktop, 0);
    padding: var(--haus-quickOrder__formRow__padding-desktop, 0.5rem 0);
    margin: var(--haus-quickOrder__formRow__margin-desktop, 0);
  }

  .formRowGrid {
    flex-direction: var(--haus-quickOrder__formRowGrid__flex-direction, row);
    justify-content: var(--haus-quickOrder__formRowGrid__justify-content, space-between);
    align-items: var(--haus-quickOrder__formRowGrid__align-items, center);
    gap: var(--haus-quickOrder__formRowGrid__gap, 0.5rem);
  }

  .inputCellActions {
    align-items: var(--haus-quickOrder__inputCellActions__align-items, flex-start);
    width: var(--haus-quickOrder__inputCellActions__width, auto);
    justify-content: var(--haus-quickOrder__inputCellActions__justify-content, flex-end);
  }

  .quantityInputGroup {
    display: var(--haus-quickOrder__quantityInputGroup__display, block);
    width: var(--haus-quickOrder__quantityInputGroup__width, auto);
  }
}
